// extracted by mini-css-extract-plugin
export default {"AddMinistry":"AddMinistry_AddMinistry__ozq6S","AddMinistry__Quill":"AddMinistry_AddMinistry__Quill__f3G4n"};